import Request from "../request";
const request = new Request();

export class ShareService {
  static list = async (
    promoCode?: string,
    sort?: string,
    search?: string,
    startDate?: string,
    endDate?: string,
    limit?: number,
    page?: number,
    excludeSelfSend?: string,
    showDetailLog?: string
  ) => {
    let params = "";

    if (promoCode) {
      params += `promoCode=${promoCode}&`;
    }
    if (sort) {
      params += `sort=${sort}&`;
    }
    if (search) {
      params += `search=${search}&`;
    }
    if (startDate) {
      params += `startDate=${startDate}&`;
    }
    if (endDate) {
      params += `endDate=${endDate}&`;
    }
    if (limit) {
      params += `limit=${limit}&`;
    }
    if (page) {
      params += `page=${page}&`;
    }
    if (excludeSelfSend) {
      params += `excludeSelfSend=${excludeSelfSend}&`;
    }
    if (showDetailLog) {
      params += `showDetailLog=${showDetailLog}&`;
    }

    const { data } = await request.get(
      "/admin/sharelog" + (params ? "?" + params.slice(0, -1) : "")
    );

    return data.data;
  };
}
